module.exports = __webpack_public_path__ + "img/bootSpeedio.bd9908bc.svg";